import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-dialog-content',
  standalone: true,
  imports: [],
  templateUrl: './dialog-content.component.html',
  styleUrl: './dialog-content.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-dialog-content',
  },
})
export class DialogContentComponent {}
